import React from "react";
import FlightDateDisplay from "../../../../../../components/DateTimeDisplay/FlightDateDisplay";

const FlightDateCellRenderer = ({ row }) => (
    <span className="schedule-draft-rdg-date-cell">
        <FlightDateDisplay
            etdOrStd={row.rawFlight?.std}
            departureAirportCode={row.rawFlight?.departure_airport}
            originalFlightDateForFallback={row.rawFlight?.flight_date}
            disableDetail
        />
    </span>
);

export default FlightDateCellRenderer;
